import React from 'react';

import { useLocation } from 'react-router-dom';
import { ROUTE_URL } from 'common/constants/SharedConstants';
import {
  getHeaderTrackOrderTemplates,
  getHeaderPickupOrderCancelledBanner,
} from '../sharedTemplates/HeaderTrackOrderViewTemplates';

/**
 *
 * @param {*} props - props for the Header Track Order View AU
 *
 */
const HeaderTrackOrderView = props => {
  const location = useLocation();
  return (
    <>
      {props?.headerTrackDetails?.userStatus?.loggedIn &&
        props?.headerTrackDetails?.isActiveOrderAvailable &&
        location?.pathname !== ROUTE_URL?.ACTIVE_ORDERS &&
        getHeaderTrackOrderTemplates(props)}
      {props?.headerTrackDetails?.showPickupOrderCancelledBanner && getHeaderPickupOrderCancelledBanner(props)}
    </>
  );
};

export default React.memo(HeaderTrackOrderView);
